var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.loading)?_c('LoadingWidget'):[_c('HeaderShell'),_c('v-main',[_c('router-view',_vm._b({},'router-view',_vm.$route.meta,false))],1),_c('FooterShell')],_c('CookieBannerWidget'),_c('WhatsAppButtonWidget')],2)}
var staticRenderFns = []

export { render, staticRenderFns }